module.exports = __webpack_public_path__ + "img/5.296de376.jpg";